/* eslint-disable array-callback-return */
import FBConfig from "../FBConfig";
import { v4 as uuid } from "uuid";
import { openDB } from "idb";
import axios from "axios";

let syncInTimer;
class ReconciliationFirebase {

  Sync_inApproved = [];
  types = [
    "category",
    "item",
    "item_group",
    "menu",
    "meal",
    "others",
    "seat",
    "payment_mode",
    "customer_group",
    "customer_data",
    "section",
    "item_availability",
    "orders",
  ];

  ReadValueFromFirebase = (
    OrgId,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues,
    updateUnSync
  ) => {
    if (!sessionStorage.getItem("_FIREBASE_CALLBACKS_SET")) {
      this.types.forEach((type) => {
        let FBRef = FBConfig.ref(
          FBConfig.db,
          OrgId + `/reconciliation/${type}/`
        );
        FBConfig.onChildAdded(FBRef, (data) => {
          this.ReadIndexDbReconciliation(
            "add",
            type,
            data,
            this.ApproveIndexedDbReconData
          );
        });
        FBConfig.onChildChanged(FBRef, (data) => {
          this.ReadIndexDbReconciliation(
            "update",
            type,
            data,
            this.ApproveIndexedDbReconData
          );
        });
        FBConfig.onChildRemoved(FBRef, (data) => {
          this.ReadIndexDbReconciliation(
            "delete",
            type,
            data,
            this.ApproveIndexedDbReconData
          );
        });
      });

      sessionStorage.setItem("_FIREBASE_CALLBACKS_SET", true);
    }

    this.setSyncIntervals(
      OrgId,
      setForceRenderOrdersPage,
      setForceRenderPage1,
      generateMenues,
      updateUnSync
    );
  };

  setSyncIntervals = async (
    OrgId,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues,
    updateUnSync,
    triggerSync
  ) => {
    if (
      (JSON.parse(sessionStorage.getItem("syncing_timers"))?.length &&
        !triggerSync) || sessionStorage.getItem('BYPASS')?.includes('SYNC')
    )
      return;
    let timersId = [];

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    if (!db) {
      this.setSyncIntervals(
        OrgId,
        setForceRenderOrdersPage,
        setForceRenderPage1,
        generateMenues,
        updateUnSync,
        triggerSync
      );
      return console.error("Could not open indexeddb");
    } else {
      if (triggerSync) {
        console.log("immidiate sync triggered");
        this.ReadIndexDbUnsyncedFiles(
          db,
          this.ApproveIndexedDbUnsyncData,
          OrgId,
          updateUnSync
        );
        setTimeout(
          () =>
            this.ReadIndexDbUnsyncedFiles(
              db,
              this.UpdateToMongoDb,
              OrgId,
              updateUnSync
            ),
          1000
        );
        JSON.parse(sessionStorage.getItem("syncing_timers")).forEach((id) =>
          clearTimeout(id)
        );
      }

      timersId[0] = setInterval(() => {
        if (+localStorage.getItem("refresh_status") === 0) {
          this.ReadIndexDbUnsyncedFiles(
            db,
            this.ApproveIndexedDbUnsyncData,
            OrgId,
            updateUnSync
          );
        }
      }, 30000);

      timersId[1] = setInterval(() => {
        if (+localStorage.getItem("refresh_status") === 0) {
          this.ReadIndexDbUnsyncedFiles(
            db,
            this.UpdateToMongoDb,
            OrgId,
            updateUnSync
          );
        }
      }, 45000);

      timersId[2] = setInterval(() => {
        if (+localStorage.getItem("refresh_status") === 0) {
          if (this.Sync_inApproved?.length) {
            localStorage.setItem(
              "syncin_approved",
              JSON.stringify(this.Sync_inApproved)
            );
            let current_time = Date.now();
            this.Sync_inApproved.filter(
              (item) => item.APPROVED_TIME < current_time
            ).map((item) => this.WriteIndexDbSync_in(item));
          }
        }
      }, 50000);

      clearInterval(syncInTimer);
      syncInTimer = setInterval(async () => {
        if (+localStorage.getItem("refresh_status") === 0) {
          await this.ReadDataFromSyncInTable().then(async (result) => {
            result?.length > 0 &&
              result?.map(
                async (item) =>
                  await this.CallGetAPI(
                    item.type,
                    item.data,
                    setForceRenderOrdersPage,
                    setForceRenderPage1,
                    generateMenues
                  )
              );
          });
        }
      }, 60000);

      sessionStorage.setItem("syncing_timers", JSON.stringify(timersId));
    }
  };

  ApproveIndexedDbUnsyncData = async (
    db,
    localUnsyncedFiles,
    OrgId,
    updateUnSync
  ) => {
    // alert("approval function called")
    const dataIndexDB = await localUnsyncedFiles.filter((a) => !a.APPROVED && a.BACKUP !== 0);
    let newData = [];
    let editedData = [];

    await dataIndexDB.map((json) => {
      if (!json.IDENTIFIER.includes("order") && !json.order_uuid)
        if (json.IDENTIFIER.includes("new")) {
          newData.push(json);
        } else {
          editedData.push(json);
        }
    });

    const approvedDocs = [];
    const disApprovedDocs = [];
    let progressCount = 0;

    const processEndCallback = (props) => this.WriteIndexeddbCollection(props);
    function docsApproveProcessHanlder(approved, doc) {
      if (approved) approvedDocs.push({ ...doc, APPROVED: 1, BACKUP: 0 });
      else disApprovedDocs.push({ ...doc, APPROVED: 0 });

      progressCount++;
      console.log(
        `FIREBASE VALIDATION PROGRESS : ${progressCount}/${newData.length + editedData.length
        }`
      );
      if (progressCount === newData.length + editedData.length) {
        // update data in db
        console.log("ALL DATA PROCESSED");
        console.log(
          `APPROVED DOCS : ${approvedDocs.length} | DISAPPROVED DOCS : ${disApprovedDocs.length}`
        );
        console.log("APPROVED : ", approvedDocs);
        console.log("DISAPPROVED : ", disApprovedDocs);

        const deleteIDBDocs = () =>
          processEndCallback({
            db,
            store_name: "unsynced_files",
            action: "delete",
            collection: disApprovedDocs,
          });
        processEndCallback({
          db,
          store_name: "unsynced_files",
          action: "update",
          collection: approvedDocs,
          callback: deleteIDBDocs,
        });
      }
    }

    await newData.map((data, i) => {
      const updateData = this.CreateData(data);
      const indexedDbData = Object.values(updateData)[0];
      const collectionRef = FBConfig.ref(
        FBConfig.db,
        OrgId +
        "/reconciliation/" +
        Object.keys(updateData)[0] +
        "/" +
        Object.values(Object.values(updateData)[0])[0]
      );

      FBConfig.get(collectionRef).then((snapshot) => {
        if (snapshot.exists()) {
          const firebaseData = snapshot.val();
          if (firebaseData.RECON_TIME < indexedDbData.RECON_TIME) {
            //Set the approved value to 1 in Unsynced files table of IndexedDB
            FBConfig.set(collectionRef, { ...indexedDbData }).then(() =>
              docsApproveProcessHanlder(true, data)
            );
          } else docsApproveProcessHanlder(false, data);
        } else {
          //if data doesn't exist in reconciliation firebase
          //Set the approved value to 1 in Unsynced files table of IndexedDB
          FBConfig.set(collectionRef, { ...indexedDbData }).then(() =>
            docsApproveProcessHanlder(true, data)
          );
        }
      });
    });

    await editedData.map((data) => {
      const updateData = this.CreateData(data);
      console.log({ updateData, data })
      if (!updateData) return progressCount++;
      const indexedDbData = Object.values(updateData)[0];
      const collectionRef = FBConfig.ref(
        FBConfig.db,
        `${OrgId}/reconciliation/${Object.keys(updateData)[0]}/${Object.values(Object.values(updateData)[0])[0]
        }`
      );

      FBConfig.get(collectionRef).then((snapshot) => {
        if (snapshot.exists()) {
          const firebaseData = snapshot.val();
          if (firebaseData.RECON_TIME < indexedDbData.RECON_TIME) {
            // Set the approved value to 1 in Unsynced files table of IndexedDB
            FBConfig.set(collectionRef, { ...indexedDbData }).then(() =>
              docsApproveProcessHanlder(true, data)
            );
          } else docsApproveProcessHanlder(false, data);
        } else {
          // if data doesn't exist in reconciliation firebase
          // Set the approved value to 1 in Unsynced files table of IndexedDB
          FBConfig.set(collectionRef, { ...indexedDbData }).then(() =>
            docsApproveProcessHanlder(true, data)
          );
        }
      });
    });
  };

  uploadedDocsIds = [];

  UpdateToMongoDb = async (
    db,
    localUnsyncedFiles,
    outlet_uuid,
    updateUnSync
  ) => {
    // alert("update to mongo function called")
    const IDB_DATA = await localUnsyncedFiles.filter(
      (i) => !this.uploadedDocsIds.includes(i.IDENTIFIER)
    );
    const outlet = localStorage.getItem("outlet_uuid");

    let dataTypeDetails = {
      Section: {
        limit: 25,
        endpoints: {
          put: `outlet/putSection/${outlet}`,
          post: `outlet/postSection/${outlet}`,
        },
      },
      Category: {
        limit: 50,
        endpoints: {
          put: `category/putItemCategory`,
          post: `category/postItemCategory`,
        },
      },
      payment_mode: {
        endpoints: {
          put: `payment/putPaymentMode`,
          post: `payment/postPaymentMode`,
        },
      },
      customer_group: {
        endpoints: {
          put: `customerGroups/putCustomerGroups`,
          post: `customerGroups/postCustomerGroups`,
        },
      },
      customer_data: {
        endpoints: {
          put: `customer/putCustomer`,
          post: `customer/postCustomerDetails`,
        },
      },
      meal: { endpoints: { put: `meal/putMeal`, post: `meal/postMeal` } },
      coupon: {
        endpoints: { post: `coupon/generate` },
        forbidden: { put: true },
      },
      role: {
        endpoints: {
          put: `roleManagement/putRoleManagement`,
          post: `roleManagement/postRoleManagement`,
        },
      },
      item_availability: {
        limit: 100,
        endpoints: { put: `item/PutItemAvailability/${outlet}` },
        forbidden: { post: true },
      },
      Seat: { limit: 25 },
      Scheme: {},
      Item: { limit: 20 },
      Menu: { limit: 1 },
      order: { endpoints: { put: `order/putorder`, post: `order/postorder` } },
      item_grouping: {
        limit: 20,
        endpoints: { put: `item/putItem` },
        forbidden: { post: true },
      },
      transaction: {
        endpoints: { post: `customerTransaction/postTransaction` },
        forbidden: { put: true },
      },
      item_stock: {
        endpoints: { put: `stocks/putStock` },
        forbidden: { post: true },
      },
      User: {},
    };

    const othersCollections = [
      "delivery_setup",
      "invoice_series",
      "invoice_setup",
      "kot_setup",
      "kds_setup",
      "kot_type",
      "upi_setup",
      "kot_colors",
      "meal_scheduling",
      "outlet_details",
      "pickup_setup",
      "swiggy_setup",
      "zomato_setup",
    ];

    let newData = [];
    let editedData = [];

    console.log("IDB_DATA : ", IDB_DATA);
    IDB_DATA.filter((unsyncFile) => unsyncFile.BACKUP === 0).map(
      ({ _id, __v, ...json }) => {
        if (json.IDENTIFIER.includes("new")) {
          newData.push(json);
        } else {
          editedData.push(json);
        }
      }
    );

    const sliceData = async (data, key) => {
      const limit = await dataTypeDetails[key]?.limit;
      if (!limit) return [data];

      const batchesCount = await Math.ceil(data.length / limit);
      const batches = [];

      for (let i = 0; i < batchesCount; i++) {
        const batch = await data.slice(i * limit, (i + 1) * limit);
        await batches.push(batch);

        if (i === batchesCount - 1) return batches;
      }
    };

    const markDocIds = (ids) => {
      console.log("before adding :", this.uploadedDocsIds);
      this.uploadedDocsIds = [...this.uploadedDocsIds, ...ids];
      console.log("after adding :", this.uploadedDocsIds);
    };

    const unMarkDocIds = (ids) => {
      console.log("before removing :", this.uploadedDocsIds);
      console.log(ids)
      this.uploadedDocsIds = ids.filter(
        (i) => !this.uploadedDocsIds.includes(i)
      );
      console.log("after removing :", this.uploadedDocsIds);
    };

    const postDelete = (count, doc_ids) => {
      updateUnSync(count);
      unMarkDocIds(doc_ids);
    };

    const callDeleteFunc = (collection) =>
      this.WriteIndexeddbCollection({
        db,
        store_name: "unsynced_files",
        action: "delete",
        collection,
        src: "UpdateToMongoDb",
        callback: postDelete,
      });

    const uploadData = async (endPoint, method, data, key) => {
      const url = `https://api.myfooddo.com/${endPoint}`;
      // const url = `http://localhost:5000/${endPoint}`;

      markDocIds(data.map((i) => i.IDENTIFIER));
      const dataBundle = await sliceData(data, key);

      const callApi = (payload) => {
        fetch(url, {
          mode: "cors",
          method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        })
          .then((res) => {
            if (+res.status === 502) {
              callApi(payload);
            } else return res.json();
          })
          .then((res_data) => {
            unMarkDocIds(
              payload
                .map((i) => i.IDENTIFIER)
                .filter(
                  (i) => !res_data?.result?.find((j) => j.IDENTIFIER === i)
                )
            );
            if (res_data.result && res_data.result.length > 0)
              callDeleteFunc(res_data.result);
          })
          .catch((err) => {
            console.warn("api request failed", err);
            unMarkDocIds(payload.map((i) => i.IDENTIFIER));
          });
      };

      dataBundle?.forEach((payload) => callApi(payload));
    };

    await Object.keys(dataTypeDetails).forEach(async (i) => {
      let getKey = (str) =>
        str
          .toLowerCase()
          .split(":")
          .filter((u) => u)[0]
          .replace("-edit", "")
          .replace("-new", "");

      if (!dataTypeDetails[i]?.forbidden?.post) {
        let newJsons = newData.filter(
          (json) => getKey(json.IDENTIFIER) === getKey(i)
        );
        if (newJsons && newJsons.length > 0) {
          let endPoint = dataTypeDetails[i]?.endpoints?.post;
          if (!endPoint) endPoint = `${i.toLowerCase()}/post${i}`;

          await uploadData(endPoint, "POST", newJsons, i);
        }
      }

      if (!dataTypeDetails[i]?.forbidden?.put) {
        let editedJsons = editedData.filter(
          (json) => getKey(json.IDENTIFIER) === getKey(i)
        );

        if (editedJsons && editedJsons.length > 0) {
          let endPoint = dataTypeDetails[i]?.endpoints?.put;
          if (!endPoint) endPoint = `${i.toLowerCase()}/put${i}`;

          await uploadData(endPoint, "PUT", editedJsons, i);
        }
      }
    });

    await othersCollections.forEach(async (i) => {
      const editedJsons = editedData.filter((json) =>
        json.IDENTIFIER.includes(i)
      );

      if (editedJsons && editedJsons.length > 0) {
        // const url = `http://localhost:5000/outlet/PutOutletObjects/${outlet}`;
        const url = `https://api.myfooddo.com/outlet/PutOutletObjects/${outlet}`;
        let nData = editedJsons[0];
        nData = [{ [i]: nData[i] }];

        await fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(nData),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data && data.success) {
              let tx = db
                .transaction("unsynced_files", "readwrite")
                .objectStore("unsynced_files");
              if (i === "invoice_series") {
                this.WriteIndexDbUnsyncedFiles(
                  tx,
                  "delete",
                  i + ":" + nData[0].invoice_series.series,
                  updateUnSync
                );
              }
              this.WriteIndexDbUnsyncedFiles(tx, "delete", i, updateUnSync);
            }
          })
          .catch((err) => console.warn("put request failed", err));
      }
    });
  };

  ReadIndexDbUnsyncedFiles = async (db, CallBackFun, OrgId, updateUnSync) => {
    // console.log("updateUnSync", OrgId, updateUnSync)

    var unsynced_files = await db
      .transaction("unsynced_files", "readonly")
      .objectStore("unsynced_files");
    let collection = await unsynced_files.getAll();

    if (collection && collection.length > 0) {
      CallBackFun(db, collection, OrgId, updateUnSync);
      updateUnSync(collection.length);
    } else {
      updateUnSync(0);
      this.uploadedDocsIds = [];
      sessionStorage.removeItem("FB_SYNCING_SETUP");
      // console.log(collection);
      await JSON.parse(sessionStorage.getItem("syncing_timers"))?.forEach(
        (id) => clearInterval(id)
      );
      sessionStorage.removeItem("syncing_timers");
    }
  };

  WriteIndexDbUnsyncedFiles = async (tx, action, data, updateUnSync) => {
    if (action === "update") {
      await tx.put(data);
    } else {
      await tx.delete(data);
    }
  };

  WriteIndexeddbCollection = async ({
    db,
    store_name,
    action,
    collection,
    callback,
    src,
  }) => {
    const store = await db
      .transaction(store_name, "readwrite")
      .objectStore(store_name);
    let progressCount = 0;

    if (collection.length > 0)
      collection.forEach((doc) => {
        if (action === "update") store.put(doc);
        else store.delete(doc.IDENTIFIER);

        progressCount++;
        if (progressCount === collection.length) {
          if (action === "update")
            console.log(
              `%c${progressCount} %cIDB Docs : ${action}d`,
              "color:#c58af9",
              "color:limegreen; font-weight:bolder"
            );
          else
            console.log(
              `%c${progressCount} %cIDB Docs : ${action}d`,
              "color:#c58af9",
              "color:red; font-weight:bolder"
            );

          if (callback)
            if (src && src === "UpdateToMongoDb") {
              const keysReq = store.getAllKeys();
              keysReq.onsuccess = (keysEvent) =>
                callback(
                  keysEvent.target.result.length,
                  keysEvent.target.result
                );
            } else callback();
        }
      });
    else callback && callback();
  };

  ApproveIndexedDbReconData = (
    localReconFiles,
    id,
    type,
    dataToApprove,
    action
  ) => {
    // console.log(dataToApprove.RECON_TIME > localStorage.getItem("login_time"), type)

    if (action === "delete") {
      this.WriteIndexDbReconFiles(action, type, dataToApprove);
    } else {
      const reconDataExists = localReconFiles?.details?.filter(
        (x) => x[id] === dataToApprove[id]
      );

      if (reconDataExists && reconDataExists.length > 0) {
        reconDataExists
          .filter((x) => x.RECON_TIME < dataToApprove.RECON_TIME, {
            IDENTIFIER: type + ":" + dataToApprove[type + "_uuid"],
            type,
            data: [dataToApprove],
            APPROVED_TIME: Date.now() + 40000,
          })
          .map(() => {
            this.WriteIndexDbReconFiles(action, type, dataToApprove);
            if (dataToApprove.RECON_TIME > localStorage.getItem("login_time")) {
              if (type === "others") {
                this.Sync_inApproved.push({
                  IDENTIFIER: type,
                  type,
                  data: [dataToApprove],
                  APPROVED_TIME: Date.now() + 40000,
                });
              } else if (type === "orders") {
                let workingDays = localStorage.getItem("dates_json");
                workingDays = JSON.parse(workingDays);
                // console.log(dataToApprove, workingDays, workingDays.filter(item => item.date === parseInt(dataToApprove.working_day)), "££££££££££3")
                if (
                  workingDays.filter(
                    (item) => item.date === parseInt(dataToApprove.working_day)
                  ).length
                ) {
                  this.Sync_inApproved.push({
                    IDENTIFIER: "order:" + dataToApprove.order_uuid,
                    type,
                    data: [dataToApprove],
                    APPROVED_TIME: Date.now() + 40000,
                  });
                }
              } else if (type === "item_availability") {
                this.Sync_inApproved.push({
                  type,
                  IDENTIFIER: "item_availability:" + dataToApprove["item_uuid"],
                  data: [dataToApprove],
                  APPROVED_TIME: Date.now() + 40000,
                });
              } else
                this.Sync_inApproved.push({
                  IDENTIFIER: type + ":" + dataToApprove[type + "_uuid"],
                  type,
                  data: [dataToApprove],
                  APPROVED_TIME: Date.now() + 40000,
                });
            }
          });
      } else {
        // console.log("---------", action, "-------", id, type, dataToApprove);
        this.WriteIndexDbReconFiles(action, type, dataToApprove);
        if (dataToApprove.RECON_TIME > localStorage.getItem("login_time")) {
          if (type === "others") {
            this.Sync_inApproved.push({
              IDENTIFIER: type,
              type,
              data: [dataToApprove],
              APPROVED_TIME: Date.now() + 40000,
            });
          } else if (type === "orders") {
            let workingDays = localStorage.getItem("dates_json");
            workingDays = JSON.parse(workingDays);
            // console.log(dataToApprove, workingDays, workingDays.filter(item => item.date === parseInt(dataToApprove.working_day)), "££££££££££3")
            if (
              workingDays.filter(
                (item) => item.date === parseInt(dataToApprove.working_day)
              ).length
            ) {
              this.Sync_inApproved.push({
                IDENTIFIER: "order:" + dataToApprove.order_uuid,
                type,
                data: [dataToApprove],
                APPROVED_TIME: Date.now() + 40000,
              });
            }
          } else if (type === "item_availability") {
            this.Sync_inApproved.push({
              type,
              IDENTIFIER: "item_availability:" + dataToApprove["item_uuid"],
              data: [dataToApprove],
              APPROVED_TIME: Date.now() + 40000,
            });
          } else
            this.Sync_inApproved.push({
              IDENTIFIER: type + ":" + dataToApprove[type + "_uuid"],
              type,
              data: [dataToApprove],
              APPROVED_TIME: Date.now() + 40000,
            });
        }
      }
    }
    // console.log(this.Sync_inApproved, ",----------------------------------))")
  };

  ReadIndexDbReconciliation = (action, type, data, CallBackFun) => {
    // console.log("111111111111...........", action, type, data)
    let DBOpenReq = indexedDB.open(
      "FoodDo",
      +localStorage.getItem("IDBVersion") || 1
    );
    DBOpenReq.addEventListener("error", (err) => {
      return null;
    });
    DBOpenReq.addEventListener("success", (ev) => {
      var tx = ev.target.result.transaction("reconciliation", "readonly");
      var reconciliation_files = tx.objectStore("reconciliation");
      let get_reconciliation_files = reconciliation_files.get(type);
      get_reconciliation_files.onsuccess = async (roconFileReq) => {
        let collection = roconFileReq.target.result;
        let id = null;
        if (type === "others") id = "type";
        if (type === "item_availability") id = "item_uuid";

        if (type === "orders") id = "order_uuid";
        else id = type + "_uuid";
        // console.log('ReadIndexDbReconciliation', data)

        const json = data.val();
        json[id] = data.key;
        CallBackFun(collection, id, type, json, action);
      };
    });
  };

  WriteIndexDbReconFiles = (action, type, data) => {
    // console.log("=-=-=-=-=", type, data, "=-=-=-=-==")
    let DBOpenReq = indexedDB.open(
      "FoodDo",
      +localStorage.getItem("IDBVersion") || 1
    );
    DBOpenReq.addEventListener("error", (err) => null);
    DBOpenReq.addEventListener("success", (ev) => {
      var tx = ev.target.result.transaction("reconciliation", "readwrite");
      var store = tx.objectStore("reconciliation");
      let get_reconciliation_files = store.getAll();
      get_reconciliation_files.onsuccess = async (roconFileReq) => {
        const allReconRecords = roconFileReq.target.result;
        const reconDataExists = allReconRecords.find(
          (curr) => curr.IDENTIFIER === type
        );
        if (reconDataExists) {
          let records = null;
          if (type === "item_availability") {
            records = reconDataExists?.details?.filter(
              (x) => x["item_uuid"] !== data["item_uuid"]
            );
          } else if (type === "orders") {
            records = reconDataExists?.details?.filter(
              (x) => x["order_uuid"] !== data["order_uuid"]
            );
          } else if (type !== "others") {
            records = reconDataExists?.details?.filter(
              (x) => x[type + "_uuid"] !== data[type + "_uuid"]
            );
          } else {
            records = reconDataExists?.details?.filter(
              (x) => x.type !== data.type
            );
          }
          let ndata = null;
          // console.log(data)
          if (type === "item_availability") {
            ndata = {
              ...data,
              item_uuid: data["item_uuid"],
              RECON_TIME: data.RECON_TIME,
            };
          } else if (type === "orders") {
            ndata = {
              ...data,
              order_uuid: data["order_uuid"],
              RECON_TIME: data.RECON_TIME,
            };
          } else if (type !== "others") {
            ndata = {
              [type + "_uuid"]: data[type + "_uuid"],
              RECON_TIME: data.RECON_TIME,
            };
          } else {
            ndata = {
              type: data.type,
              RECON_TIME: data.RECON_TIME,
            };
          }

          // delete data
          if (action === "delete") {
            const editData = {
              ...reconDataExists,
              details: [...records],
            };
            if (editData) {
              store.put(editData);
            }
          } else {
            // update data
            const editData = {
              ...reconDataExists,
              details: [...records, ndata],
            };
            if (editData) {
              // console.log('write into idb reconciliation:',editData);
              store.put(editData);
            }
          }
        } else {
          let newData = null;
          if (type === "item_availability") {
            newData = {
              IDENTIFIER: type,
              details: [
                {
                  item_uuid: data["item_uuid"],
                  RECON_TIME: data.RECON_TIME,
                },
              ],
            };
          } else if (type === "orders") {
            newData = {
              IDENTIFIER: type,
              details: [
                {
                  ...data,
                  order_uuid: data["order_uuid"],
                  RECON_TIME: data.RECON_TIME,
                },
              ],
            };
          } else if (type !== "others") {
            newData = {
              IDENTIFIER: type,
              details: [
                {
                  [type + "_uuid"]: data[type + "_uuid"],
                  RECON_TIME: data.RECON_TIME,
                },
              ],
            };
          } else {
            newData = {
              IDENTIFIER: type,
              details: [
                {
                  type: data.type,
                  RECON_TIME: data.RECON_TIME,
                },
              ],
            };
          }
          // add new data
          if (newData) {
            store.add(newData);
          }
        }
      };
    });
  };

  WriteIndexDbSync_in = (data) => {
    let DBOpenReq = indexedDB.open(
      "FoodDo",
      +localStorage.getItem("IDBVersion") || 1
    );
    DBOpenReq.addEventListener("error", (err) => {
      return null;
    });
    DBOpenReq.addEventListener("success", (ev) => {
      var tx = ev.target.result.transaction("sync_in", "readwrite");
      var store = tx.objectStore("sync_in");
      store.put(data);
    });
  };

  ReadDataFromSyncInTable = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const unsynced_files = await db
      .transaction("unsynced_files", "readonly")
      .objectStore("unsynced_files")
      ?.getAll();
    if (unsynced_files?.length) return [];
    const tx = await db
      .transaction("sync_in", "readonly")
      .objectStore("sync_in");
    return await tx.getAll();
  };

  CallGetAPI = async (
    collection,
    content,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues
  ) => {
    let endPoint = null;
    const outlet = localStorage.getItem("outlet_uuid");
    let data = content[0];

    if (collection === "item_group") {
      endPoint = `item/getItemGrouping/${outlet}`;
    } else if (collection === "section") {
      endPoint = `outlet/getSection`;
    } else if (collection === "category") {
      endPoint = `category/getCategory`;
    } else if (collection === "seat") {
      endPoint = `outlet/getSeatData`;
    } else if (collection === "meal") {
      endPoint = `meal/getMeal`;
    } else if (collection === "payment_mode") {
      endPoint = `payment/getPayment`;
    } else if (collection === "customer_group") {
      endPoint = `customerGroups/getCustomerGroups`;
    } else if (collection === "customer_data") {
      endPoint = `customer/getCustomer`;
    } else if (collection === "menu") {
      endPoint = `menu/getMenu/${data?.menu_uuid}`;
    } else if (collection === "item") {
      endPoint = `item/getItem`;
    } else if (collection === "orders") {
      endPoint = `order/getOrder`;
    }

    const url = `https://api.myfooddo.com/${endPoint}`;

    if (
      collection === "item" ||
      collection === "seat" ||
      collection === "meal" ||
      collection === "menu" ||
      collection === "payment_mode" ||
      collection === "customer_group" ||
      collection === "customer_data" ||
      collection === "category" ||
      collection === "orders" ||
      collection === "item_group"
    ) {
      // console.log("MongoDB>>>url", url, data);

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then(async (ResultData) => {
          // console.log("Get succeeded...", ResultData);
          if (ResultData.success) {
            if (collection === "orders") {
              collection = "order";
              let customer_mobile = ResultData.result.customer_mobile;
              if (customer_mobile !== "") {
                this.updateCustomer(customer_mobile);
              }
              // console.log("ResultData", ResultData)
            }
            this.updateLocalDb(
              ResultData.result,
              collection,
              collection + ":" + ResultData.result[collection + "_uuid"],
              setForceRenderOrdersPage,
              setForceRenderPage1,
              generateMenues
            );
          }
        })
        .catch((err) => console.warn("post request failed", err));
    }
    if (collection === "others" || collection === "section") {
      // console.log("MongoDB>>>url", url, data);
      fetch("https://api.myfooddo.com/outlet/GetOutletObjects/" + outlet, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify([data]),
      })
        .then((res) => res.json())
        .then((content) => {
          const result = content.data;
          result.map((item) => {
            // console.log("@@@@", item, data, "@@@@@")
            this.updateLocalOutletDb(
              data,
              collection === "others" ? "others" : "section",
              collection === "others"
                ? data?.type
                : "section:" + data[0]?.section_uuid,
              item,
              setForceRenderOrdersPage,
              setForceRenderPage1,
              generateMenues
            );
          });
        })
        .catch((err) => console.warn("error in fetching details", err));
    }
    if (collection === "item_availability") {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      const tx = await db.transaction("item", "readwrite").objectStore("item");
      const syncInFiles = await tx.getAll();
      await syncInFiles
        .filter((item) => item.item_uuid === data.item_uuid)
        .map(async (item) =>
          this.updateItemAvailability(
            item,
            collection + ":" + item.item_uuid,
            data,
            setForceRenderOrdersPage,
            setForceRenderPage1,
            generateMenues
          )
        );
    }
  };

  updateItemAvailability = async (
    data,
    IDENTIFIER,
    item,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues
  ) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("item", "readwrite").objectStore("item");
    // console.log(data, "-------------------------------------------------", item)
    await tx.put({
      ...data,
      outlet_wise_item_details: data.outlet_wise_item_details.map((item2) => ({
        ...item2,
        other_details: {
          ...item2.other_details,
          item_availability: item.item_availability,
        },
      })),
    });
    await this.SyncInDb(
      IDENTIFIER,
      setForceRenderOrdersPage,
      setForceRenderPage1,
      generateMenues
    );
    this.Sync_inApproved = await this.Sync_inApproved.filter(
      (item) => item.IDENTIFIER !== IDENTIFIER
    );
    localStorage.setItem("syncin_approved", this.Sync_inApproved);
  };

  updateLocalDb = async (
    data,
    type,
    IDENTIFIER,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues
  ) => {
    // console.log({ ...data, IDENTIFIER: data[type + "_uuid"] }, type, IDENTIFIER)
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction(
        type === "item_group"
          ? "item_grouping"
          : type === "order"
            ? "Orders"
            : type === "payment_mode"
              ? "payment_modes"
              : type === "customer_group"
                ? "customer_groups"
                : type === "customer_data"
                  ? "customer"
                  : type === "seat"
                    ? "seats"
                    : type,
        "readwrite"
      )
      .objectStore(
        type === "item_group"
          ? "item_grouping"
          : type === "order"
            ? "Orders"
            : type === "payment_mode"
              ? "payment_modes"
              : type === "customer_group"
                ? "customer_groups"
                : type === "customer_data"
                  ? "customer"
                  : type === "seat"
                    ? "seats"
                    : type
      );
    await tx.put({ ...data, IDENTIFIER: data[type + "_uuid"] });
    await this.SyncInDb(
      IDENTIFIER,
      setForceRenderOrdersPage,
      setForceRenderPage1,
      generateMenues
    );
    this.Sync_inApproved = await this.Sync_inApproved.filter(
      (item) => item.IDENTIFIER !== IDENTIFIER
    );
    localStorage.setItem(
      "syncin_approved",
      this.Sync_inApproved.filter((item) => item.IDENTIFIER !== IDENTIFIER)
    );
  };

  updateLocalOutletDb = async (
    data,
    type,
    IDENTIFIER,
    mongoData,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues
  ) => {
    // console.log(data, type, IDENTIFIER, mongoData)

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");
    const outletData = await tx.get(localStorage.getItem("outlet_uuid"));

    if (data.type === "invoice_series" && +localStorage.getItem("user_type") !== 3) {
      console.log("datas : ", { data, type, IDENTIFIER, mongoData });
      let mongo_user_series = mongoData[data.type]?.find(
        (s) => s.user_uuid === localStorage.getItem("user_uuid")
      );
      let local_user_series = outletData[data.type]?.find(
        (s) => s.user_uuid === localStorage.getItem("user_uuid")
      );

      console.log("mongo_user_series", mongo_user_series);
      console.log("local_user_series", local_user_series);

      let biggerSeries = [mongo_user_series, local_user_series].sort(
        (a, b) => +b.next_order_number - +a.next_order_number
      )[0];

      console.log("bigger user series", biggerSeries);

      mongoData[data.type] = outletData[data.type]?.map((s) =>
        s.user_uuid === biggerSeries.user_uuid ? biggerSeries : s
      );
    }

    let updatedOutlet = { ...outletData, [data.type]: mongoData[data.type] };

    await tx.put(updatedOutlet);
    await this.SyncInDb(
      IDENTIFIER,
      setForceRenderOrdersPage,
      setForceRenderPage1,
      generateMenues
    );
    if (type === "others") {
      this.Sync_inApproved = await this.Sync_inApproved.filter(
        (item) => item.data[0].type !== IDENTIFIER
      );
      localStorage.setItem(
        "syncin_approved",
        this.Sync_inApproved.filter((item) => item.data[0].type !== IDENTIFIER)
      );
      this.SyncInDb(
        type,
        setForceRenderOrdersPage,
        setForceRenderPage1,
        generateMenues
      );
    } else {
      this.Sync_inApproved = await this.Sync_inApproved.filter(
        (item) => item.IDENTIFIER !== IDENTIFIER
      );
      localStorage.setItem(
        "syncin_approved",
        this.Sync_inApproved.filter((item) => item.IDENTIFIER !== IDENTIFIER)
      );
      this.SyncInDb(
        IDENTIFIER,
        setForceRenderOrdersPage,
        setForceRenderPage1,
        generateMenues
      );
    }
  };

  static softReloadTimer;
  SyncInDb = async (
    IDENTIFIER,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues
  ) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("sync_in", "readwrite")
      .objectStore("sync_in");
    await tx.delete(IDENTIFIER);

    if (!this.softReloadTimer)
      this.softReloadTimer = setTimeout(() => {
        if (window.location.pathname.includes("/orders"))
          setForceRenderOrdersPage(uuid() + uuid());
        else if (window.location.pathname.includes("/page1"))
          setForceRenderPage1(uuid() + uuid());
        generateMenues();
        this.softReloadTimer = null;
      }, 5000);
  };

  updateCustomer = async (customer_mobile) => {
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = await db
      .transaction("customer", "readwrite")
      .objectStore("customer");
    let customerLocal = await tx.getAll();
    let customerLocalData = customerLocal.filter(
      (a) => a.customer_mobile === customer_mobile
    );
    if (customerLocalData.length === 0) {
      const response = await axios({
        method: "post",
        url: "https://api.myfooddo.com/customer/getCustomerDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          customer_mobile,
        },
      });
      // console.log("response", response)
      let responseData = response.data.result;
      let data = {
        ...responseData,
        IDENTIFIER: responseData.customer_mobile,
        customer_payment_details: [],
      };
      // console.log("response", data)
      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = await db
        .transaction("customer", "readwrite")
        .objectStore("customer");
      await tx.put(data);
    }
  };

  CreateData = (data) => {
    let outData = "";
    const ids1 = [
      "seat",
      "section",
      "category",
      "item",
      "menu",
      "meal",
      "role",
      "payment_mode",
      "customer_group",
      "customer_data"
    ];
    const ids2 = [
      "delivery_setup",
      "invoice_series",
      "invoice_setup",
      "kot_setup",
      "kds_setup",
      "kot_type",
      "upi_setup",
      "meal_scheduling",
      "outlet_details",
      "pickup_setup",
      "swiggy_setup",
      "zomato_setup",
      "kot_colors",
    ];

    let getKey = (str) =>
      str
        .toLowerCase()
        .split(":")
        .filter((u) => u)[0]
        .replace("-edit", "")
        .replace("-new", "");

    let y = ids1
      .filter((str) => getKey(data.IDENTIFIER) === str)
      .map((str) => {
        const id = data.IDENTIFIER.substr(
          data.IDENTIFIER.indexOf(":") + 1,
          data.IDENTIFIER.length
        );
        const x = {
          [str]: {
            [str + "_uuid"]: id,
            RECON_TIME: data.RECON_TIME,
          },
        };
        return x;
      });

    if (y[0]) {
      outData = y[0];
    }
    let y2 = ids2
      .filter((str) => data.IDENTIFIER.includes(str) === true)
      .map((str) => {
        const x = {
          others: {
            type: str,
            RECON_TIME: data.RECON_TIME,
          },
        };
        return x;
      });

    if (y2[0]) {
      outData = y2[0];
    }
    if (data.IDENTIFIER.includes("item_availability")) {
      const id = data.IDENTIFIER.substr(
        data.IDENTIFIER.indexOf(":") + 1,
        data.IDENTIFIER.length
      );
      const x = {
        item_availability: {
          item_uuid: id,
          item_availability: data.item_availability,
          RECON_TIME: data.RECON_TIME,
        },
      };
      outData = x;
      // outData = {item_availability};
    }
    if (data.IDENTIFIER.includes("item_group")) {
      const x = {
        item_group: {
          item_group_uuid: data.item_group_uuid,
          RECON_TIME: data.RECON_TIME,
        },
      };
      outData = x;
      // outData = {item_availability};
    }

    // console.log('Firebase>>>>>>>>CreateIdentifier', outData, "------", data)
    return outData;
  };
}

const reconciliationFirebase = new ReconciliationFirebase();
export default reconciliationFirebase;